export default (htmlDocument = document) => htmlDocument.activeElement;
